import { WalletContext } from 'contexts/walletContext'
import { useContext } from 'react'

export const useWalletContext = () => useContext(WalletContext)
